import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 's'
})
export class SPipe implements PipeTransform {

	transform(value: number): string {
		return value > 1 ? 's' : ''
	}
}
